<template>
    <v-card class="mb-6">
        <v-list-item-subtitle>Options</v-list-item-subtitle>
        <v-card-text>
            <v-select
            :items="passengersItems"
            v-model="passengers"
            label="No. of passengers (including children)"
            dense
            @change="CHECK_AND_CALCULATE_FARE"
            ></v-select>
            <v-select
            :items="items"
            v-model="luggage"
            label="Excess luggage (more than 1 checked and 1 carry on piece per passenger)"
            dense
            @change="CHECK_AND_CALCULATE_FARE"
            ></v-select>
            <v-select
            :items="items"
            v-model="surfboards"
            label="Surfboards (less than 2m only)"
            dense
            @change="CHECK_AND_CALCULATE_FARE"
            ></v-select>
            <v-select
            :items="items"
            v-model="bicycles"
            label="Bicycles"
            dense
            @change="CHECK_AND_CALCULATE_FARE"
            ></v-select>
            <v-select
            :items="items"
            v-model="golfClubs"
            label="Sets of golf clubs"
            dense
            @change="CHECK_AND_CALCULATE_FARE"
            ></v-select>
            <v-select
            :items="items"
            v-model="boardBags"
            label="Board bags"
            dense
            @change="CHECK_AND_CALCULATE_FARE"
            ></v-select>
            <v-select
            :items="items"
            v-model="skisSnowboards"
            label="Skis / Snowboards"
            dense
            @change="CHECK_AND_CALCULATE_FARE"
            ></v-select>
            <v-select
            :items="items"
            v-model="babyCapsules"
            label="Rear facing baby seat(s)"
            dense
            ></v-select>
            <v-select
            :items="items"
            v-model="babySeats"
            label="Forward facing baby seat(s)"
            dense
            ></v-select>
            <v-select
            :items="items"
            v-model="boosterSeats"
            label="Booster seats"
            dense
            ></v-select>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import storeConstants from '@/store/storeConstants';

export default {
  name: 'LuggageOptions',
  computed: {
    // The `mapFields` function takes an array of
    // field names and generates corresponding
    // computed properties with getter and setter
    // functions for accessing the Vuex store.
    ...mapFields([
      'booking.passengers',
      'booking.luggage',
      'booking.surfboards',
      'booking.bicycles',
      'booking.golfClubs',
      'booking.babyCapsules',
      'booking.babySeats',
      'booking.boosterSeats',
      'booking.boardBags',
      'booking.skisSnowboards',
    ]),
  },
  data: () => ({
    passengersItems: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
    items: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
  }),
  methods: {
    ...mapActions([
      storeConstants.CHECK_AND_CALCULATE_FARE]),
  },
};
</script>
